import React, { useEffect, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import type { TenantThemeConfig } from '../types/theme'
import * as authService from '../services/authService'
import { getThemeById } from '../config/themes'
import ModernLotteryResultSections from '../components/lottery-result/ModernLotteryResultSections'
import { resolveReferralToken } from '../services/affiliateService'

interface AssetConfig {
  CDN_BASE_URL: string
  CSS_PATH: string
  IMG_PATH: string
  FONTS_PATH: string
}

interface ModernHomePageProps {
  themeConfig: TenantThemeConfig
  assetConfig: AssetConfig
}

const IMG_PLACEHOLDER = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
const AFFILIATE_REFERRAL_KEY = 'affiliate_referral_code'

const ModernHomePage: React.FC<ModernHomePageProps> = ({ themeConfig, assetConfig }) => {
  const navigate = useNavigate()
  const themeFolder = useMemo(() => getThemeById(themeConfig.themeId)?.folder ?? 'HuayToday-Blue', [themeConfig.themeId])
  useEffect(() => {
    if (authService.isAuthenticated()) return
    const params = new URLSearchParams(window.location.search)
    const ref = params.get('ref')
    const aff = params.get('aff')
    if (ref && ref.trim()) {
      resolveReferralToken(ref.trim())
        .then(({ referralCode }) => {
          sessionStorage.setItem(AFFILIATE_REFERRAL_KEY, referralCode)
          navigate(`/register${window.location.search}`, { replace: true })
        })
        .catch(() => { /* invalid/expired ref */ })
    } else if (aff && aff.trim()) {
      sessionStorage.setItem(AFFILIATE_REFERRAL_KEY, aff.trim())
      navigate(`/register${window.location.search}`, { replace: true })
    }
  }, [navigate])

  const getAssetUrl = (path: string) => {
    const base = assetConfig.CDN_BASE_URL ? `${assetConfig.CDN_BASE_URL}/${themeFolder}` : `/${themeFolder}`
    return base + (path.startsWith('/') ? path : `/${path}`)
  }
  const handleImgError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    const el = e.currentTarget
    if (el.dataset.imgFallback === '1') return
    el.dataset.imgFallback = '1'
    el.src = IMG_PLACEHOLDER
  }

  return (
    <div className="h_login animateMe" data-animation="fadeInUp">
      <ModernLotteryResultSections
        tenantId={themeConfig.tenantId}
        showDatePicker={false}
        showTitle
        getAssetUrl={getAssetUrl}
        handleImgError={handleImgError}
        showPoolError
        wipWupMinutes={themeConfig.settings?.wipWupMinutes}
        className="row mx__1"
      />
    </div>
  )
}

export default ModernHomePage
